<template>
  <main>
    <van-cell-group>
      <van-cell
        id="bill-code"
        :value="data.bill_code"
        title="订单号" />
      <van-cell
        id="bill-code"
        :value="productName"
        title="商品名称" />
      <van-cell
        :value="data.create_time"
        title="创建时间" />
      <van-cell
        :value="data.bill_status"
        title="订单状态" />
    </van-cell-group>
    <div class="mt-3 mb-5">
      <OrderDetailItem
        v-for="item of data.bill_items"
        :data="item"
        :disabled="productName === '名医诊断'"
        :key="item.image_id"/>
      <div
        v-if="data.bill_status === '等待支付'"
        class="p-3">
        <van-button
          type="primary"
          size="large"
          @click="handleOnCancel">取消订单</van-button>
      </div>
      <div
        v-if="productName === '名医诊断' && data.diagnosis_status === '已写报告'"
        class="p-3">
        <van-button
          type="primary"
          size="large"
          @click="doctorReport">查看名医报告</van-button>
      </div>
      <!-- eslint-disable max-len -->
      <div
        v-if="productName === '名医诊断' && data.bill_status === '已完成' && data.diagnosis_status === '待写报告'"
        class="hint mt-3 p-4">
        感谢您使用专家看片服务，我们将在24小时内安排医生为您看片，请您及时关注短息提醒。
      </div>
    </div>
    <!-- <van-submit-bar
      :price="data.total_bill_price"
      :button-text="buttonText"
      :loading="loading"
      :button-type="data.bill_status !== '等待支付' ? 'primary' : 'danger'"
      @submit="handleOnPayment"
    /> -->
    <div class="fixed-bottom d-flex bottom-ground">
      <span
        class="flex-grow-1"
        style="background-color: #fff;"></span>
      <!-- 电子胶片的 -->
      <span
        v-if="productName === '电子胶片'">
        <span
          v-show="data.bill_current_price_yuan !== data.bill_price_yuan"
          class="original-price">
          <del>合计: {{ data.bill_price_yuan.toFixed(2) }} 元</del>
        </span>
        <span class="price">
          {{ data.bill_current_price_yuan === data.bill_price_yuan ? '合计' : '推广价' }}:
          {{ data.bill_current_price_yuan.toFixed(2) }} 元
        </span>
      </span>
      <!-- 名医的 -->
      <span v-if="productName === '名医诊断'">
        <span
          v-show="data.bill_items[0].current_price_yuan !== data.bill_items[0].price_yuan"
          class="original-price">
          <del>合计: {{ data.bill_items[0].price_yuan.toFixed(2) }} 元</del>
        </span>
        <span class="price">
          {{ data.bill_items[0].current_price_yuan === data.bill_items[0].price_yuan ? '问诊费用' : '推广价' }}:
          {{ data.bill_items[0].current_price_yuan.toFixed(2) }} 元
        </span>
      </span>
      <van-button
        type="danger"
        class="rounded-0"
        @click="handleOnPayment">{{ buttonText }}</van-button>
    </div>
  </main>
</template>

<script>
import OrderDetailItem from './components/OrderDetailItem.vue';

export default {
  name: 'OrderDetail',
  components: {
    OrderDetailItem,
  },
  data() {
    return {
      data: {},
      loading: false,
      productName: '',
    };
  },
  computed: {
    buttonText() {
      if (this.data.bill_status === '等待支付') {
        return '去支付';
      }
      return this.data.bill_status;
    },
  },
  activated() {
    this.handleLoad();
  },
  methods: {
    async handleLoad() {
      const billCode = this.$route.params.id;
      if (billCode.slice(0, 2) === 'MY') {
        const response = await this.$http.get('/cloud-film-api/webapi/order/get-by-user', {
          orderId: billCode,
        });
        const bill = {
          bill_code: response.order_code,
          create_time: response.create_time,
          bill_status: response.order_status,
          bill_items: response.order_items,
          diagnosis_status: response.diagnosis_status, // 报告状态
        };
        this.data = bill;
        this.productName = '名医诊断';
      } else {
        this.data = await this.$http.get('/cloud-film-api/webapi/bill/get-bill', {
          bill_code: billCode,
        });
        this.productName = '电子胶片';
      }
    },
    async handleOnPayment() {
      if (this.data.bill_status === '等待支付') {
        const routerLink = `/cloud-film/payment?billCode=${this.$route.params.id}`;
        // this.$router.push(routerLink);
        window.location.href = routerLink;
      } else {
        // const routerLink = '/cloud-film/account/order';
        this.$router.go(-1);
        // window.location.href = routerLink;
      }
    },
    async handleOnCancel() {
      const billCode = this.$route.params.id;
      if (billCode.slice(0, 2) === 'MY') {
        await this.$http.post('/cloud-film-api/webapi/order/cancel-order', {
          bill_code: billCode,
        });
      } else {
        await this.$http.post('/cloud-film-api/webapi/bill/cancel-bill', {
          bill_code: billCode,
        });
      }
      this.$toast.success('订单已取消');
      this.$router.push({ name: 'order' });
    },
    doctorReport() {
      this.$router.push({ name: 'doctor-report', params: { id: this.data.bill_code } });
    },
  },
};
</script>

<style>
  #bill-code > .van-cell__title {
    flex-grow: 0.5;
  }

  .hint {
    background-color: #fff;
    font-size: 18px;
  }

  .bottom-ground {
    background-color: #fff;
  }

  .price {
    /* background-color: #fff; */
    line-height: 44px;
    padding-right: 12px;
    color: #f44;
    text-align: right;
  }

  .original-price {
    /* background-color: #fff; */
    line-height: 44px;
    /* font-size: 14px; */
    text-align: right;
    padding-right: 4px;
  }
</style>
